<template>
  <div class="phtContent" :key="JSON.stringify(renderData)">
    <!-- <p>{{ renderData }}</p> -->
    <!-- normal_pht 段落（句子）层级 -->
    <div
      class="normal_pht"
      v-for="(paragraph, rindex) in renderData"
      :key="rindex"
      :style="{ 'justify-content': baseStyles.justifyContent }"
    >
      <!-- pht_single ‘拼音加汉字’ 的一个整体单位 -->
      <div
        :class="[
          'pht_single',
          item.text && showPinyin && item.pinyin
            ? 'pht_single_pinyin'
            : 'pht_single_text',
        ]"
        v-for="(item, index) in paragraph"
        :key="JSON.stringify(item) + index"
        :style="{
          ...writingSpacing,
          textIndent: baseStyles.hasIndent || '',
          marginLeft:
            (item.text === '空' && item.margin && item.isMargin) ? wordSpacing:(
              item.margin || type === 'hasTian' || index === 0
              ? '0px'
              : item.pinyin
              ? wordSpacing
              : '0px'
            ),
        }"
      >
        <template v-if="item.blank === 'input' && !ifSet">
          <div class="pht_input">
            <div class="pht_input_box" :style="{ borderColor: item.color }">
              <input
                type="text"
                class="pht_input_blank"
                :maxlength="parseInt(item.width)"
                :ref="`input${item.inputIndex}`"
                :style="{ width: item.inputWidth, color: item.color }"
                :key="blankInput[item.inputIndex]"
                :value="blankInput[item.inputIndex]"
                :disabled="inputMode != 1"
                @change="inputChange($event, item)"
              />
              <img
                v-show="inputMode == '1' && !blankInput[item.inputIndex]"
                class="pht_input_img"
                src="../../../../assets/images/edit_input.png"
                @click="clickInputImg(item.inputIndex)"
              />
            </div>
            <p v-if="item.pinyin" style="font-family:'pinyinFont'">（{{ item.pinyin }}）</p>
          </div>
        </template>
        <template v-else-if="item.blank === 'input' && ifSet">
          <div class="pht_set_input">
            {{ questionIndex + item.inputCount }}
          </div>
        </template>
        <template v-else-if="onlyPinyin">
          <p
            class="pinyin"
            v-if="item.text && showPinyin && item.pinyin"
            :style="isEssay && index === 0 ? titlePinyinStyle : hzStyle"
          >
            <span v-if="evalXml"
              ><span
                :style="{
                  color: evalXml ? (item.sheng ? '#06CA9F' : '#EB5564') : '',
                }"
                >{{ item.shengmu }}</span
              >
              <span
                :style="{
                  color: evalXml ? (item.yun ? '#06CA9F' : '#EB5564') : '',
                }"
                >{{ item.yunmu }}</span
              ></span
            >
            <span
              :style="{
                color: item.color,
              }"
              v-if="!evalXml && item.text.length === 1"
              >{{ item.pinyin }}</span
            >
            <span v-if="!evalXml && item.text.length > 1">
              <span :style="{ color: item.color }">{{
                item.pinyin.slice(0, -1)
              }}</span>
              <span :style="{ color: item.color2 }">{{
                item.pinyin[item.pinyin.length - 1]
              }}</span>
            </span>
          </p>
        </template>
        <template v-else>
          <div
            v-if="item.blank === 'underline'"
            class="underline"
            :style="{
              width: (item.width ? item.width : 2) * 30 + 'px',
              height: '100%',
              borderBottom: '1px solid rgba(73,79,90,1)',
              textAlign: 'center',
            }"
          >
            {{ item.text }}
          </div>
          <!-- 拼音 start-->
          <p
            class="pinyin"
            v-if="item.text && showPinyin && item.pinyin"
            :style="isEssay && index === 0 ? titlePinyinStyle : pinyinStyle"
          >
            <span v-if="evalXml"
              ><span
                :style="{
                  color: evalXml ? (item.sheng ? '#06CA9F' : '#EB5564') : '',
                }"
                >{{ item.shengmu }}</span
              >
              <span
                :style="{
                  color: evalXml ? (item.yun ? '#06CA9F' : '#EB5564') : '',
                }"
                >{{ item.yunmu }}</span
              ></span
            >
            <span
              :style="{
                color: item.color,
              }"
              v-if="!evalXml && item.text.length === 1"
              >{{ item.pinyin }}</span
            >
            <span v-if="!evalXml && item.text.length > 1">
              <span :style="{ color: item.color }">{{
                item.pinyin.slice(0, -1)
              }}</span>
              <span :style="{ color: item.color2 }">{{
                item.pinyin[item.pinyin.length - 1]
              }}</span>
            </span>
          </p>
          <!-- <p
          v-if="showPinyin && !item.pinyin"
          :style="isEssay && index === 0 ? titlePinyinStyle : pinyinStyle"
          class="pinyin"
        >
          &nbsp;
        </p> -->
          <!-- 拼音 end -->
          <!-- 一般样式的汉字 start -->
          <p
            class="hz"
            v-if="item.blank != 'underline' && type === 'normal'"
            :style="isEssay && index === 0 ? titleHzStyle : hzStyle"
          >
            <template v-if="item.blank!='space'">{{ item.blank }}</template>
            <!-- 纯字符串特殊处理 -->
            <span
              v-if="item.type === 'string'"
              :style="{
                color: evalXml
                  ? item.syll
                    ? '#06CA9F'
                    : '#EB5564'
                  : item.color,
                marginTop:
                  showPinyin && !item.pinyin ? pinyinStyle.lineHeight : '0px',
              }"
            >
              <span v-for="(ii, index) in item.text" :key="ii + index" :style="!ii||ii==' ' ? 'min-width:14px;display:inline-block;':'', {'display':ii == '\n' ? 'block' :''}">{{ii === " " ? ii.replace(/\s/g,'&nbsp;&nbsp;') : ii}}</span>
            </span>
            <span
              v-else-if="item.type==='stringTag'"
              :style="{
                color: evalXml
                  ? item.syll
                    ? '#06CA9F'
                    : '#EB5564'
                  : item.color,
                marginTop:
                  showPinyin && !item.pinyin ? pinyinStyle.lineHeight : '0px',
              }"
              class="string-tag"
              v-html="item.text"
            >
            </span>
            <!-- 适配空格的情况 -->
            <span
              v-else-if="item.text===' '"
              style="min-width:8px;display:inline-block;"
              >{{ item.text }}</span
            >
            <span
              v-else-if="item.text.length === 1"
              :style="{
                color: evalXml
                  ? item.syll
                    ? '#06CA9F'
                    : '#EB5564'
                  : item.color,
                marginTop:
                  showPinyin && !item.pinyin ? pinyinStyle.lineHeight : '0px',
                visibility: !!item.space ? 'hidden' : 'visible',
              }"
              >{{ item.text }}</span
            >
            <!-- 儿化音特殊处理 -->
            <span
              v-else-if="item.text.length === 2"
              :style="{
                color: evalXml
                  ? item.syll
                    ? '#06CA9F'
                    : '#EB5564'
                  : item.color,
                marginTop:
                  showPinyin && !item.pinyin ? pinyinStyle.lineHeight : '0px',
              }"
            >
              <span :style="{ color: item.color }">{{ item.text[0] }}</span>
              <span :style="{ color: item.color2 || item.color }">{{
                item.text[1]
              }}</span>
            </span>
            <span
              v-else
              :style="{
                color: item.color,
                marginTop:
                  showPinyin && !item.pinyin ? pinyinStyle.lineHeight : '0px',
              }"
              >{{ item.text }}</span
            >
          </p>
          <!-- 一般样式的汉字 end -->
          <!-- 带有田字格的汉字 start -->
          <div
            class="tianBox"
            :style="tianBoxStyle"
            v-if="type === 'hasTian' && item.text"
          >
            <p class="t_hz" :style="hzStyle" v-if="item.text.length === 1">
              <span
                :style="{
                  color:
                    item.pinyin && evalXml
                      ? item.syll
                        ? '#06CA9F'
                        : '#EB5564'
                      : item.color,
                }"
                >{{ item.text }}</span
              >
            </p>
            <p class="t_hz" v-else-if="item.text.length === 2">
              <span
                v-for="hzItem in item.text.split('')"
                :key="hzItem"
                :style="{
                  ...(hzItem === '儿'
                    ? half_subordinate_hzStyle
                    : half_main_hzStyle),
                  color: hzItem === '儿' ? item.color2 : item.color,
                }"
                >{{ hzItem }}</span
              >
            </p>
            <p class="t_hz" :style="hzStyle" v-else-if="item.text.length === 3">
              <span
                :style="{
                  color:
                    item.pinyin && evalXml
                      ? item.syll
                        ? '#06CA9F'
                        : '#EB5564'
                      : item.color,
                  'letter-spacing':
                    '-' +
                    (Number(baseStyles.hzFontSize.split('px')[0]) * 4) / 5 +
                    'px',
                  'margin-left':
                    '-' +
                    (Number(baseStyles.hzFontSize.split('px')[0]) * 4) / 5 +
                    'px',
                }"
                >{{ item.text }}</span
              >
            </p>
          </div>
          <!-- </div> -->
          <!-- 带有田字格的汉字 end -->
        </template>
      </div>
    </div>
    <!-- <p>{{renderData}}</p> -->
  </div>
</template>

<script>
// author: ylli19

import x2js from "x2js";
const parser = new DOMParser();
const $x2js = new x2js();
export default {
  name: "phoneticText",
  props: {
    // 是否是带有标题的文章
    isEssay: {
      type: Boolean,
      default: false,
    },
    /* 
      渲染类型
      'normal': 一般的样式 包括 词语、句子、单段落
      'hasTian': 有田字格的单字
    */
    type: {
      type: String,
      default: "normal",
    },
    // 是否显示拼音
    showPinyin: {
      type: Boolean,
      default: true,
    },
    // 初始渲染字符串:'<span> <font></font> </span>'
    originData: {
      type: String,
      default: "",
    },
    // 评测类型，与调用评测引擎设置的传参category保持一致
    evalType: {
      type: String,
      default: "read_sentence",
    },
    // 评测结果xml
    evalXml: {
      type: String,
      default: "",
    },
    // 是否首行空两格
    ifShowSpace: {
      type: Boolean,
      default: false,
    },
    // 是否是套题
    ifSet: {
      type: Boolean,
      default: false,
    },
    //如果是套题，传入第一个题号
    questionIndex: {
      type: Number,
      default: 1,
    },
    // 初始状态（未评测）渲染样式
    baseStyles: {
      type: [Object, Function],
      default: () => {
        return {
          // 拼音文本初始颜色
          originPinyinColor: "#3E4651",
          // 拼音文本字体大小
          pinyinFontSize: "14px",
          // 拼音文本 行高
          pinyinLineHeight: "14px",
          // 汉字文本初始颜色
          originHzColor: "#3E4651",
          // 拼音文本字体大小
          hzFontSize: "26px",
          // 汉字文本 行高
          hzLineHeight: "26px",
          // 行文 间距(下方间距)
          writingSpacing: "20px",
          // 显示居中
          justifyContent: "flex-start",
          // 分词间距
          wordSpacing: "0px",
        };
      },
    },
    // 田字格样式
    tianStyles: {
      type: Object,
      default: () => {
        return {
          // 方格尺寸
          size: "150px",
          // 多字情况下的方格间距
          spacing: "4px",
        };
      },
    },
    // 输入框模式
    // 1: 作答模式
    // 2: 显示模式
    inputMode: {
      type: String,
      default: "1",
    },
    // 是否只显示拼音
    onlyPinyin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      blankInputIndex: 0,
      blankInput: {},
    };
  },
  computed: {
    wordSpacing() {
      return this.baseStyles.wordSpacing || "0px";
    },
    tianBoxStyle() {
      return {
        width: this.tianStyles.size,
        height: this.tianStyles.size,
        marginRight: this.tianStyles.spacing,
      };
    },
    writingSpacing() {
      return {
        marginBottom: this.baseStyles.writingSpacing,
      };
    },
    pinyinStyle() {
      return {
        marginBottom: "5px",
        color: this.baseStyles.originPinyinColor,
        fontSize: this.baseStyles.pinyinFontSize,
        lineHeight: this.baseStyles.pinyinLineHeight,
      };
    },
    titlePinyinStyle() {
      return {
        color: this.titleStyles.originPinyinColor,
        fontSize: this.titleStyles.pinyinFontSize,
        lineHeight: this.titleStyles.pinyinLineHeight,
      };
    },
    titleHzStyle() {
      return {
        color: this.titleStyles.originHzColor,
        fontSize: this.titleStyles.hzFontSize,
        lineHeight: this.titleStyles.hzLineHeight,
      };
    },
    hzStyle() {
      return {
        color: this.baseStyles.originHzColor,
        fontSize: this.baseStyles.hzFontSize,
        lineHeight: this.baseStyles.hzLineHeight,
      };
    },
    half_main_hzStyle() {
      return {
        color: this.baseStyles.originHzColor,
        fontSize: (Number(this.baseStyles.hzFontSize.split("px")[0]) * 4) / 5 + "px",
        lineHeight: (Number(this.baseStyles.hzLineHeight.split("px")[0]) * 4) / 5 + "px",
      };
    },
    half_subordinate_hzStyle() {
      return {
        color: this.baseStyles.originHzColor,
        fontSize: (Number(this.baseStyles.hzFontSize.split("px")[0]) * 2) / 5 + "px",
        lineHeight: (Number(this.baseStyles.hzLineHeight.split("px")[0]) * 2) / 5 + "px",
      };
    },
    //判断是否是汉字
    isHzFun(str) {
      let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
      return reg.test(str);
    },

    // 计算 当前状态的渲染数据
    renderData() {
      if (this.evalXml) {
        let resultWordsArr = this.getResultWordsArr();
        let originData = this._renderScreenText(this.originData);
        let count = 0;
        let reg = new RegExp("[\\u4E00-\\u9FFF]+", "g");
        originData.forEach((item, index) => {
          item.forEach((it, inx) => {
            if (reg.test(it.text)) {
              // if (it.pinyin) {
              originData[index][inx] = Object.assign(originData[index][inx], resultWordsArr[count]);
              if (originData[index][inx].text === "儿" && !originData[index][inx].pinyin) {
                originData[index][inx - 1].text += "儿";
                originData[index][inx].text = "";
              }
              if (originData[index][inx].text === "儿" && originData[index][inx].pinyin === "r") {
                originData[index][inx - 1].text += "儿";
                originData[index][inx - 1].pinyin += "r";
                originData[index][inx].text = "";
                originData[index][inx].pinyin = "";
              }
              count++;
            }
          });
        });
        // console.log('originData:', originData)
        return originData;
      } else {
        return this._renderScreenText(this.originData);
      }
    },
  },
  created() {},
  methods: {
    // 解析初始数据字段为json
    _renderScreenText(str) {
      const xmlDoc = parser.parseFromString(str, "text/xml");
      const chars = xmlDoc.querySelectorAll("font");
      if (!chars || chars.length == 0) {
        return [
          [
            {
              text: str.replace(/\.{3}/g, "···"),
              color: "black",
              type: str.includes("<u>") ? "stringTag" : "string", // 标识为待html标签的纯字符串：<u></u>等
            },
          ],
        ];
      }
      // const color = chars[0].getAttribute('color')
      let index = 0;
      let inputCount = -1;
      let items = [];
      items[0] = [];
      for (let i = 0; i < chars.length; i++) {
        if (chars[i].getAttribute("break")) {
          index++;
          items[index] = new Array();
        }
        if (
          chars[i].textContent ||
          chars[i].getAttribute("blank") === "underline" ||
          chars[i].getAttribute("blank") === "input" ||
          chars[i].getAttribute("blank") === "space"
        ) {
          if (chars[i].getAttribute("blank") === "input") {
            inputCount++;
          }
          let singObj = {
            text: chars[i].textContent,
            pinyin: chars[i].getAttribute("pinyin"),
            shengmu: chars[i].getAttribute("shengmu"),
            yunmu: chars[i].getAttribute("yunmu"),
            margin: chars[i].getAttribute("margin"),
            color: chars[i].getAttribute("color") || "#000",
            break: chars[i].getAttribute("break"),
            blank: chars[i].getAttribute("blank"),
            width: chars[i].textContent.split(",").length
              ? chars[i].getAttribute("width") * chars[i].textContent.split(",").length
              : chars[i].getAttribute("width"),
            ignore: chars[i].getAttribute("ignore"),
            inputCount: inputCount,
          };
          // 特殊处理填空题
          if (chars[i].getAttribute("blank") === "input") {
            singObj.inputIndex = this.blankInputIndex++;
            singObj.inputWidth = parseInt(singObj.width) <= 2 ? "70px" : (parseInt(singObj.width) - 2) * 20 + 70 + "px";

            if (this.inputMode == "2") {
              this.$set(this.blankInput, singObj.inputIndex, singObj.text);
              singObj.color = chars[i].getAttribute("correct") == "1" ? "#09CBA0" : "#FDA35A";
            } else {
              singObj.color = "#1C84FE";
            }
          }
          if (this.evalXml) {
            items[index].push(singObj);
          } else {
            if (singObj.text === "儿" && !singObj.pinyin) {
              let pos = items[index].length;
              if (pos >= 1) {
                items[index][pos - 1].text += "儿";
                items[index][pos - 1].color2 = singObj.color;
              } else {
                items[index].push(singObj);
              }
            } else if (singObj.text === "儿" && singObj.pinyin === "r") {
              let pos = items[index].length;
              items[index][pos - 1].text += "儿";
              items[index][pos - 1].pinyin += "r";
              items[index][pos - 1].color2 = singObj.color;
            } else if (singObj.blank === "space") {
              // 特殊处理空格
              singObj.space = true;
              (singObj.text = "空"), items[index].push(singObj);
            } else if (singObj.text === "." && (chars[i - 1].textContent === "." || chars[i + 1].textContent === ".")) {
              // 特殊处理省略号居中问题
              singObj.text = "·";
              items[index].push(singObj);
            } else if (singObj.text === "…") {
              // 特殊处理省略号居中问题
              singObj.text = "···";
              items[index].push(singObj);
            } else {
              items[index].push(singObj);
            }
          }
        }
      }
      console.log(items);
      const _items = [...items[0]];
      if (this.ifShowSpace) {
        items.forEach((item) => {
          let spaceObj = {
            blank: null,
            break: null,
            color: "#000",
            margin: 10,
            pinyin: null,
            shengmu: null,
            text: "空",
            width: null,
            yunmu: null,
            space: true,
            isMargin: _items.filter((item) => item.pinyin).length, //判断其他文本是否带有拼音,有拼音有margin-left，没有拼音没有margin-left
          };
          item.splice(0, 0, spaceObj, spaceObj);
        });
      }
      return items;
    },
    // 评测结果xml转化为json对象
    getResultWordsArr() {
      let xmlJsonStr = $x2js.xml2js(this.evalXml);
      let sentences =
        xmlJsonStr.xml_result[this.evalType].rec_paper.sentence ||
        xmlJsonStr.xml_result[this.evalType].rec_paper[this.evalType].sentence;
      console.log("sentences:", sentences);
      let wordArr = [];
      if (this.isObjArr(sentences) === "Array") {
        sentences.forEach((items) => {
          items.word.forEach((ite) => {
            let content = ite._content;
            let it = ite.syll.phone || ite.syll[1].phone;
            let pyStates = {};
            let yun, sheng;
            yun = (it[0]._is_yun === "0" ? it[0]._perr_msg : it[1]._perr_msg) === "0";
            sheng = (it[0]._is_yun === "0" ? it[1]._perr_msg : it[0]._perr_msg) === "0";
            pyStates = {
              yun,
              sheng,
              content,
              syll: yun && sheng,
            };
            wordArr.push(pyStates);
          });
        });
      } else {
        if (this.isObjArr(sentences.word) === "Array") {
          sentences.word.forEach((ite) => {
            let content = ite._content;
            let it = ite.syll.phone || ite.syll[1].phone;
            let pyStates = {};
            let yun, sheng;
            yun = (it[0]._is_yun === "0" ? it[0]._perr_msg : it[1]._perr_msg) === "0";
            sheng = (it[0]._is_yun === "0" ? it[1]._perr_msg : it[0]._perr_msg) === "0";
            pyStates = {
              yun,
              sheng,
              content,
              syll: yun && sheng,
            };
            wordArr.push(pyStates);
          });
        } else {
          let content = sentences.word._content;
          let it = sentences.word.syll.phone || sentences.word.syll[1].phone;
          let pyStates = {};
          let yun, sheng;
          console.log(it);
          yun = (it[0]._is_yun === "0" ? it[0]._perr_msg : it[1]._perr_msg) === "0";
          sheng = (it[0]._is_yun === "0" ? it[1]._perr_msg : it[0]._perr_msg) === "0";
          pyStates = {
            yun,
            sheng,
            content,
            syll: yun && sheng,
          };
          wordArr.push(pyStates);
        }
      }
      return wordArr;
    },
    // 基础方法：判断当前对象是否为数组
    isObjArr(value) {
      if (Object.prototype.toString.call(value) === "[object Array]") {
        return "Array";
      } else if (Object.prototype.toString.call(value) === "[object Object]") {
        return "Object";
      }
    },
    clickInputImg(index) {
      this.$refs[`input${index}`][0].focus();
    },
    inputChange(event, item) {
      let text = event.target.value;

      // 处理输入字符, 过滤全部空格
      text = text.replace(/\s/g, "");
      text = text.substr(0, parseInt(item.width) || 1);

      // 实现双向绑定
      event.target.value = text;
      this.$set(this.blankInput, item.inputIndex, text);

      // 判断是否填空完成
      let isFinished = false;
      let blankKeys = Object.keys(this.blankInput);
      isFinished = blankKeys.length === this.blankInputIndex;
      if (isFinished) {
        isFinished = blankKeys.every((key) => {
          return this.blankInput[key];
        });
      }

      this.$emit("inputChange", this.blankInput, isFinished);
    },
  },
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "pinyinFont";
  src: url(../../../../assets/font/pinyin.ttf);
}
.normal_pht {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  word-break: break-word;
  &:nth-child(2) {
    margin-top: 10px;
  }
  .pht_input {
    margin: 0 5px;
    display: flex;
    flex-direction: row;

    &_box {
      position: relative;
      border-bottom: 1px solid #1c84fe;
    }

    .pht_input_img {
      cursor: pointer;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -8px;
      width: 15px;
      height: 16px;
    }
    &_blank {
      min-width: 70px;
      padding: 0 10px;
      text-align: center;
      border: none;
      background: none;
      outline: none;

      &:focus + .pht_input_img {
        display: none;
      }
    }
  }
  .pht_set_input {
    width: 70px;
    height: 20px;
    line-height: 20px;
    color: #FAAE56;
    font-size: 12px;
    text-align: center;
    border-bottom: 1px solid #FAAE56;
    margin-bottom: 5px;
  }
  .pht_single {
    // min-width: 24px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    &_pinyin {
      text-align: center !important;
      .hz {
        align-self: center;
      }
    }
    &_text {
      text-align: left !important;
      .hz {
        align-self: flex-start;
        ::v-deep u {
          text-decoration: none;
          border-bottom: 1px solid;
        }
      }
    }
    .pinyin {
      font-family: "pinyinFont";
    }
    .mutiTian {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: flex-start;
    }
    .tianBox {
      background-image: url(../../../../assets/images/tian.png);
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "华文楷体" !important;
      font-weight: 600;
      .t_hz {
        margin: 0 !important;
      }
    }
  }
}
</style>
